import { readFromLocalStorage, getVideoType } from "../../services/localStorage";
import { SET_LANGUAGES, SET_CURRENT_LANGUAGE, SET_TOUR_LANGUAGE } from "../actions/languageActions";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import type { LanguageAction } from "../actions/languageActions";
import type { LanguageState, LanguageInfo } from "../../types/language";

const initialState: LanguageState = {
    appLanguages: null,
    currentLanguage: (readFromLocalStorage(STORAGE_KEYS.LEGACY_LANGUAGE) as string) || null,
    direction: (readFromLocalStorage(STORAGE_KEYS.LEGACY_DIRECTION) as LanguageState['direction']) || 'ltr',
    tourLanguage: getVideoType() || null,
}

const languageReducer = (state: LanguageState = initialState, action: LanguageAction): LanguageState => {
    switch (action.type) {
        case SET_LANGUAGES: {
            const languages: Record<string, LanguageInfo> = {};
            action.payload.forEach(language => {
                languages[language.languages_code.code!] = language.languages_code;
            });

            return {...state, appLanguages: languages}
        }
        case SET_CURRENT_LANGUAGE:
            return {
                ...state, currentLanguage: action.payload, direction: state.appLanguages![action.payload].direction || 'ltr'
            }
        case SET_TOUR_LANGUAGE:
            return {
                ...state, tourLanguage: action.payload
            }
        default:
            return state
    }
}

export default languageReducer;
